module.exports = {

  closeOpenedArticles() {
    let articlesCollapsed = document.getElementsByClassName("article-collapsed");
    let articlesExpanded = document.getElementsByClassName("article-expanded");

    if (articlesCollapsed && articlesExpanded && articlesCollapsed.length > 0 && articlesExpanded.length > 0){
      for(let i=0; i < articlesCollapsed.length; ++i){
        articlesExpanded[i].setAttribute("style", "display: none");
        articlesCollapsed[i].setAttribute("style", "display: block");
      }
    }
  }
};